import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const createInvite = async (payload) => {
  const res = await axios.post(`${API}/invites`, payload, { headers: getHeaders() });
  return res.data;
};

export const getInvite = async (inviteId) => {
  const res = await axios.get(`${API}/invites/${inviteId}`);
  return res.data;
};

export const getHostInvites = async () => {
  const res = await axios.get(`${API}/invites/host`, { headers: getHeaders() });
  return res.data;
};

export const syncHostDetectedReservations = async () => {
  const res = await axios.post(`${API}/host/ical/sync-now`, {}, { headers: getHeaders() });
  return res.data;
};

export const requestInviteAccess = async (inviteId, payload) => {
  const res = await axios.post(`${API}/invites/${inviteId}/request-access`, payload, { headers: getHeaders() });
  return res.data;
};

export const acceptInvite = async (inviteId) => {
  const res = await axios.post(`${API}/invites/${inviteId}/accept`, {}, { headers: getHeaders() });
  return res.data;
};

export const confirmDetectedInvite = async (inviteId) => {
  const res = await axios.post(`${API}/invites/${inviteId}/confirm-detected`, {}, { headers: getHeaders() });
  return res.data;
};

export const declineDetectedInvite = async (inviteId) => {
  const res = await axios.post(`${API}/invites/${inviteId}/decline-detected`, {}, { headers: getHeaders() });
  return res.data;
};

export const approveInvite = async (inviteId) => {
  const res = await axios.post(`${API}/invites/${inviteId}/approve`, {}, { headers: getHeaders() });
  return res.data;
};

export const declineInvite = async (inviteId) => {
  const res = await axios.post(`${API}/invites/${inviteId}/decline`, {}, { headers: getHeaders() });
  return res.data;
};

export const removeInvite = async (inviteId) => {
  const res = await axios.delete(`${API}/invites/${inviteId}`, { headers: getHeaders() });
  return res.data;
};

export const cancelHostInvite = async (inviteId) => {
  const res = await axios.post(`${API}/invites/${inviteId}/cancel`, {}, { headers: getHeaders() });
  return res.data;
};